<template>
    <div>
        <hts-ui-tabs
            v-model="tab"
            :tabs="tabs"
            key-id="key" />

        <vehicle v-if="tab === 'vehicle'" />
        <driver v-if="tab === 'driver'" />
        <remooc v-if="tab === 'remooc'" />
    </div>
</template>
<script setup lang="ts">
import vehicle from './vehicle/index.vue'
import driver from './driver/index.vue'
import remooc from './remooc/index.vue'
const tab = ref('')

onBeforeMount(() => {
  tab.value = 'vehicle'
})

const tabs = [
  {
    key: 'vehicle',
    label: 'Đầu xe'
  },
  {
    key: 'remooc',
    label: $t('labels.mooc')
  },
  {
    key: 'driver',
    label: $t('labels.driver')
  }
]
</script>
